module.exports = __webpack_public_path__ + "img/hugo-logo.095748d4.svg";